<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="auto !important"
    class="bg-white pos-relative"
  >
    <v-card class="dir-ltr">
      <v-card-title class="fs-1-5r bg-grey mb-4">
        SFTP Access Details
      </v-card-title>
      <v-card-text class="font-size-16 px-2 pb-2"> Protocol: SFTP </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2"> Host: {{ computedHost }} </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2"> Port: 22 </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2">
        Username: {{ computedUsername }}
      </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2">
        Password: {{ userName }} Yazam MFT password
      </v-card-text>
      <v-divider></v-divider>
      <div class="d-flex justify-space-between pa-4">
        <Button
          :clickAction="sendEmailClicked"
          width="fit-content"
          btnType="blue"
          class="mr-4"
          text="Send Email"
        />
        <Button
          :clickAction="closeDialog"
          width="fit-content"
          btnType="grey"
          text="Cancel"
        />
      </div>
    </v-card>
    <InsertEmailDialogForCasual
      v-if="isShowInsertDialog"
      :closeDialog="() => (isShowInsertDialog = false)"
      :sftpUsername="computedUsername"
      :isTarget="true"
    />
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import InsertEmailDialogForCasual from '@/components/BaseComponents/CasualCommonComponents/InsertEmailDialogForCasual.vue'

export default {
  name: 'SftpDetailsDialog',
  data() {
    return {
      dialog: true,
      isShowInsertDialog: false,
    }
  },
  props: {
    userEmail: String,
    userName: String,
    closeDialog: Function,
  },
  components: { Button, InsertEmailDialogForCasual },

  computed: {
    computedHost() {
      return window.location.host
    },
    computedUsername() {
      return `${this.userEmail}\\Guest Accounts`
    },
  },
  methods: {
    sendEmailClicked() {
      this.isShowInsertDialog = true
    },
  },
}
</script>

<style scoped>
.select-senders {
  padding: 0px 8px 7px 0px;
  display: flex;
  align-items: center;
}
</style>
